// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-label{width:7.135417rem;text-align:right!important}.ang{margin-top:.9375rem;margin-bottom:.416667rem}.ang p img{width:100%!important}", ""]);
// Exports
module.exports = exports;
